import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV, SITE } from "@/lib/site";

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="sticky top-0 z-50 backdrop-blur-md border-b"
      style={{
        background: "rgba(247, 246, 242, 0.85)",
        borderColor: "var(--rr-border)",
      }}
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12 flex items-center justify-between h-20">
        <Link
          to="/"
          className="flex items-baseline gap-2 group"
          data-testid="logo-link"
          onClick={() => setOpen(false)}
        >
          <span className="font-serif text-2xl sm:text-[26px] leading-none tracking-tight" style={{ color: "var(--rr-text)" }}>
            Rewire <span style={{ color: "var(--rr-accent)" }}>&</span> Root
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-9">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={item.testid}
              className={({ isActive }) =>
                `rr-link text-sm tracking-wide ${isActive ? "is-active" : ""}`
              }
              style={{ color: "var(--rr-text)" }}
            >
              {item.label}
            </NavLink>
          ))}
          <Link
            to="/enroll"
            data-testid="header-enroll-cta"
            className="text-sm font-medium px-5 py-3 transition-colors"
            style={{
              background: "var(--rr-primary)",
              color: "var(--rr-bg)",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "var(--rr-primary-hover)")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "var(--rr-primary)")}
          >
            Enroll — {SITE.priceLabel}
          </Link>
        </nav>

        <button
          className="md:hidden p-2"
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          style={{ color: "var(--rr-text)" }}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          className="md:hidden border-t"
          style={{ borderColor: "var(--rr-border)", background: "var(--rr-bg)" }}
          data-testid="mobile-menu"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`m-${item.testid}`}
                className={({ isActive }) =>
                  `text-base ${isActive ? "underline underline-offset-4" : ""}`
                }
                style={{ color: "var(--rr-text)" }}
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/enroll"
              onClick={() => setOpen(false)}
              data-testid="m-header-enroll-cta"
              className="mt-2 text-sm font-medium px-5 py-3 inline-block text-center"
              style={{ background: "var(--rr-primary)", color: "var(--rr-bg)" }}
            >
              Enroll — {SITE.priceLabel}
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
